// extracted by mini-css-extract-plugin
export default {"conversationWrapper":"styles_conversationWrapper__N8-oz"};